import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section data-testid="not-found" className="evg-section bg-white min-h-[70vh] flex items-center">
      <div className="evg-container">
        <div className="evg-overline">404</div>
        <h1 className="font-serif mt-5 text-5xl md:text-6xl leading-tight">
          The page you were looking for cannot be found.
        </h1>
        <p className="mt-6 evg-body max-w-xl">
          The page may have moved or no longer exists. Return to the homepage to explore Evergreen
          Global Holdings Ltd and our strategic platforms.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-10 inline-block text-[11px] uppercase tracking-[0.2em] font-medium px-6 py-4 bg-[#0A1F44] text-white border border-[#0A1F44] hover:bg-transparent hover:text-[#0A1F44] transition-colors"
        >
          Return Home
        </Link>
      </div>
    </section>
  );
}
